import { useWatch } from 'react-hook-form';
import { Box, Collapse } from '@mui/material';
import { RhfFractionField, RhfSelect, RhfTextField } from '@core/components';
import type { EnumOption } from '@core/utils/enum';
import {
  CENTER_FINISH_DESIGN_TYPES,
  type DesignFormValues,
} from '../utils/design';

interface DesignFormFieldsProps {
  vestmentTypeOptions: EnumOption[];
  vestmentTypeLocked?: boolean;
}

export function DesignFormFields({
  vestmentTypeOptions,
  vestmentTypeLocked = false,
}: DesignFormFieldsProps) {
  const vestmentType = useWatch<DesignFormValues, 'vestmentType'>({
    name: 'vestmentType',
  });

  return (
    <>
      <RhfTextField<DesignFormValues> name="code" label="Code" required />
      <Box sx={{ display: 'flex', gap: 2 }}>
        <RhfSelect<DesignFormValues>
          name="vestmentType"
          label="Vestment Type"
          required
          options={vestmentTypeOptions}
          disabled={vestmentTypeOptions.length === 1 || vestmentTypeLocked}
          sx={{ flex: 1 }}
        />
        <Collapse
          in={CENTER_FINISH_DESIGN_TYPES.includes(vestmentType)}
          orientation="horizontal"
          unmountOnExit
        >
          <RhfFractionField<DesignFormValues>
            name="centerFinish"
            label="Center Finish (in)"
            sx={{ width: 150 }}
          />
        </Collapse>
      </Box>
    </>
  );
}
